import { createAction, handleActions } from 'redux-actions';
import { get } from 'lodash/fp';

const SET_AUTH_TOKEN = 'admin/SET_AUTH_TOKEN';
const RESET_AUTH_TOKEN = 'admin/RESET_AUTH_TOKEN';

const setAdminAuthTokenAC = createAction(SET_AUTH_TOKEN);
const resetAdminAuthTokenAC = createAction(RESET_AUTH_TOKEN);

const adminAuthTokenSelector = get('adminSession.access_token');
const adminUserSelector = get('adminSession.user');

const authTokenReducer = handleActions(
  {
    [SET_AUTH_TOKEN]: (state, { payload }) => payload,
    [RESET_AUTH_TOKEN]: () => null,
  },
  null
);

export {
  setAdminAuthTokenAC,
  resetAdminAuthTokenAC,
  adminAuthTokenSelector,
  adminUserSelector,
};

export default {
  adminSession: authTokenReducer,
};
